import IssueGenericLoading from './IssueGenericLoading';

/**
 * Displays the loading state for a licensing issue.
 */
const LicensingIssueLoading = () => {
  return (
    <IssueGenericLoading>
      {(contentStartY) => {
        return (
          <>
            {/* Issue Details */}
            <rect x="0" y={contentStartY + 70} rx="3" ry="3" width="95%" height="140" />
            {/* File Matches */}
            <rect x="0" y={contentStartY + 220} rx="3" ry="3" width="95%" height="300" />
            {/* Dependency */}
            <rect x="0" y={contentStartY + 530} rx="3" ry="3" width="95%" height="140" />
            {/* All licenses */}
            <rect x="0" y={contentStartY + 680} rx="3" ry="3" width="95%" height="140" />
          </>
        );
      }}
    </IssueGenericLoading>
  );
};

export default LicensingIssueLoading;
